module.exports = __webpack_public_path__ + "img/success.39b4c431.png";